import { useMemo } from 'react'

import { StatusResult } from '@cash-web/protos/squareup/franklin/status_result.pb'
import { ModalVariant } from '@cash-web/shared-feature-modal'
import { BlockerType } from '@cash-web/shared-flow-data-access-context'
import { JourneyData, JourneyTarget } from '@cash-web/shared-journey-util-main'
import { isMobileDevice } from '@cash-web/shared-util-user-agent'

import { JourneyStore, useJourneyStoreSyncOnBlockerChange } from './JourneyStoreProvider'

const isMobile = isMobileDevice()
const targetOverride: Partial<Record<BlockerType, JourneyTarget>> = {
  // the card_customization blocker target should not be overridden on mobile where it uses an outlet target
  card_customization: isMobile ? 'mobile-sheet' : 'fullscreen',
}

export const getModalVariant = (journey: JourneyData): ModalVariant | undefined => {
  return journey.routeConfig?.modalVariant ?? (journey.opts?.['modalVariant'] as ModalVariant | undefined)
}
export const getTarget = (journey: JourneyData, blockerType?: BlockerType, statusResult?: StatusResult) => {
  const modalVariant = getModalVariant(journey)
  const blocker = !blockerType && !statusResult ? journey.initialBlocker : blockerType

  let target = modalVariant === 'fullscreen' ? 'fullscreen' : journey.routeConfig?.target ?? journey.opts?.scope?.target
  if (blocker && targetOverride[blocker]) {
    target = targetOverride[blocker]
  }

  return target
}

export const getTargetHistory = (history: JourneyData[], store?: JourneyStore) => {
  const targetHistory: Partial<Record<JourneyTarget, JourneyData[]>> = {}

  for (const journey of history) {
    const storeInstance = store?.getSnapshot(journey.journeyId)
    const statusResult = storeInstance?.flow?.active?.statusResult
    const blockerType = storeInstance?.flow?.active?.blockerData?.type
    const target = getTarget(journey, blockerType, statusResult) ?? 'modal'
    targetHistory[target] ??= []
    targetHistory[target].push(journey)
  }

  return targetHistory
}

export const useTargetHistory = (history: JourneyData[]) => {
  const { store, syncValue } = useJourneyStoreSyncOnBlockerChange()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => getTargetHistory(history, store), [history, store, syncValue])
}
